<template>
    <div :class="$style['review-goods-ifame']">
        <el-dialog title="商品详情效果预览" :visible="isDialog" class="goods-review-dialog" @close="closeDialog">
            <iframe v-if="isDialog" :src="iframeUrl" :class="$style['review-iframe']" frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    goodsId: {
      type: String,
      default: ''
    },
    integral: Boolean
  },
  data () {
    return {
      apiServer: this.$apiServerMobile
    }
  },
  computed: {
    iframeUrl () {
      return this.integral ? `${this.apiServer}/integral-goods-detail/${this.goodsId}?platform=PC` : `${this.apiServer}/commodity-detail/${this.goodsId}?platform=PC`
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style lang="less" module>
.review-goods-ifame{
:global
.goods-review-dialog{
    overflow: hidden;
    .el-dialog{
        margin-top: 3%!important;
        height: 94%;
        display: flex;
        width: 30%;
        min-width: 350PX;
        max-width: 400PX;
        flex-direction:column;
        .el-dialog__header{
            .el-dialog__title{
                width: 100%;
                text-align: center;
                display: block
            }
        }
        .el-dialog__body{
            border: 1px dashed #4A91FD;
            padding: 5px;
            flex: 1
        }
    }

}
}
.review-iframe{
    width: 100%;
    height: 100%;
}
</style>
